import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseMiscApiService } from '../../../_common/api/base-misc-api.service';
import { AppConstants } from '../../app.constants';
import { MediaTypes } from 'src/app/_common/services/files.service';

@Injectable({
    providedIn: 'root'
})
export class PolicyMiscApiService extends BaseMiscApiService
{
    private endPoint = '/latestpolicies';

    constructor(http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlHist;
        this.segmentApi = '/hist/netbackup';
    }

    export (qs: string, format: MediaTypes): Observable<HttpEvent<Blob>>
    {
        return this.download(`/export${this.endPoint}${qs}`, format);
    }
}
